import React from 'react';
import { Button } from '../../../../components/Button';
import { asDate } from '../../shared/utils/dashboard-page.utils';
import { AdminSessionAuditView } from '../../../../services/admin-sessions/admin-sessions.service';
import { FilterMode } from '../../shared/types/dashboard-page.types';
import classes from './load-previous-shift-section.module.scss';

export type LoadPreviousShiftSectionProps = {
  filterMode: FilterMode;
  loadedSessionIds: number[];
  sessions: AdminSessionAuditView[];
  onLoadPreviousShift: () => void;
};

export const LoadPreviousShiftSection: React.FC<LoadPreviousShiftSectionProps> = ({
  filterMode,
  loadedSessionIds,
  sessions,
  onLoadPreviousShift,
}) => {
  if (filterMode !== 'shift') {
    return null;
  }

  const orderedSessions = [...sessions].sort((a, b) => new Date(b.openTime).getTime() - new Date(a.openTime).getTime());
  const known = new Set(loadedSessionIds);
  const loadedIndexes = loadedSessionIds
    .map((sessionId) => orderedSessions.findIndex((row) => row.sessionId === sessionId))
    .filter((index) => index >= 0);
  const oldestLoadedIndex = loadedIndexes.length > 0 ? Math.max(...loadedIndexes) : -1;
  const nextSession = orderedSessions.slice(oldestLoadedIndex + 1).find((row) => !known.has(row.sessionId));

  if (!nextSession) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      <Button variant="save" size="sm" onClick={onLoadPreviousShift} dataTestId="dashboard-load-previous-shift">
        טען משמרת קודמת ({asDate(nextSession.openTime)})
      </Button>
    </div>
  );
};
